import { ampli } from 'lib-shared-tracking';
import { memo, useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { TopbarButton } from 'app/views/layout/components/layoutContainer/components/topBar/components/button/topbarButton';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { CommandName } from 'utils/commands';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { TopbarButtonOld } from '../topbarButtonOld';

export const CommandLauncherTopbarButton = memo(
  function CommandLauncherTopbarButton(): JSX.Element {
    const flags = useFeatureFlag(['new-topbar']);
    const dispatch = useAppDispatch();

    const openCommandLauncher = useCallback(() => {
      ampli.commandExecuted({
        commandName: 'app:commandLauncher' satisfies CommandName,
        location: 'topbar',
      });

      dispatch(
        appActions.showModal({ modal: { type: 'app:commandLauncher' } }),
      );
    }, [dispatch]);

    const label = 'Command launcher';

    const tooltip = (
      <CommandKeybindingsTooltipContent commandName="app:commandLauncher">
        {label}
      </CommandKeybindingsTooltipContent>
    );

    return flags.newTopbar ? (
      <TopbarButton
        icon="search"
        label={label}
        tooltip={tooltip}
        onClick={openCommandLauncher}
        data-cmdk-details-expand-helper
      />
    ) : (
      <TopbarButtonOld
        onClick={openCommandLauncher}
        icon="bolt"
        tooltip={tooltip}
        data-cmdk-details-expand-helper
      />
    );
  },
);
